import {
    React,
    Sidebar,
  } from "@/imports-files/pages/clients/jobs/automations";
  
  //--------------------StyleSheet -------------------
  import ButtonStyle from "@/styles/components/button/_index.module.scss";
  import PageStyle from "@/styles/pages/clients/job-sharing/_index.module.scss";
  import CandidateStyle from "@/styles/pages/clients/compare_candidates/_index.module.scss";
  //--------------------StyleSheet -------------------

  //-------------------- Components --------------
  import Image from "next/image";
  import Link from 'next/link';
  import Select from "react-select";
  export {SingleCandidateModal} from '@/components/modals/single-candidate-modal';

  //-------------------- Components --------------

  //-------------------Image --------------------
  import Fb from 'public/icons/fbicon.png';
  import Twi from 'public/icons/twittericon.png';
  import Li from 'public/icons/linkedicon.png';
  import BackArrow from 'public/icons/compare_candidates/arrowback.svg';
  import ArrowLeft from 'public/icons/arrowleft.svg';
  import UpwardArrow from 'public/icons/compare_candidates/arrowupward.svg';


  //-------------------Image --------------------

  //------------------Custom Components -------------
  import Button from "@/components/button";
  //------------------Custom Components -------------


export { React,Sidebar,ButtonStyle,Button,PageStyle,CandidateStyle,Image,Link,Select,Fb,Twi,Li, BackArrow,UpwardArrow, ArrowLeft};
export {SendRequest} from '@/services/common/send-request';
export {JobSharing} from '@/services/pages/clients/jobs/job-sharing'
export {getActiveIds, handleActiveJobBoard, socialIcons, handleJobSharingFormSubmit, getJobSharingData, shouldRenderSuggestions, renderInputComponent, getUserSuggestionValue, renderUserSuggestion, onUserSuggestionsFetchRequested, onUserSuggestionsClearRequested, isEmail, onUserSuggestionSelection, handleKeyDown, handleEmailDelete, isJobForApproval} from '@/actions/pages/clients/jobs/job-sharing'
export { API, AutocompleteError, axios, clearSWRCache, DataFromUrl, Field, FieldArray, Form, Formik, FormikControl, goToNextPage, handleOtherResponseCode, imageSize, JOB_STEPS, motion, 
         NextServerCookies, PAGE_ANIMATION_OPTIONS, RESOURCE_NOT_FOUND_REPONSE_CODE, REDIRECT, SUCCESS_REPONSE_CODE, toastr, TRANSLATION, 
         UNPROCESSABLE_ENTITY_RESPONSE_CODE, useEffect, useQueryClient, useRouter, useState, useSWR, useTranslation, Yup, CustomToastrAction, InputError, InputText, Tooltip, useRef, ErrorPages, Checkbox} from '@/imports-files/common/common';
export {default as BacktoAllJobs} from '@/pages/clients/jobs/back-all-jobs-modal';
export {draftJob, previewJob, startDateMessage, hideDraft, cursorNone, jobStatusBadge, arrayEquals} from '@/actions/pages/clients/jobs/common'
// export {default as JobPreviewPage} from '@/pages/clients/dashboard/jobs/job-preview'
export {default as JobLivePopup} from "@/components/job-live";
export { ConfirmationModal } from '@/components/confirmation-modal';
export { closeModalUsingState } from '@/actions/common/close-modal';
export { AddNewAgencyUser } from '@/components/add-new-agency-user-modal';